import React, {
  useRef, useEffect, useLayoutEffect, useState,
} from 'react';
import classNames from 'classnames';
import * as ReactDOM from 'react-dom';
import './ContextMenu.scss';

export default function ContextMenu(props) {
  const {
    item = null,
    event = null,
    renderContextMenu = () => {},
    onClose = () => {},
  } = props;
  const blockRef = useRef(null);
  const [style, setStyle] = useState({
    left: event?.clientX || 0,
    top: event?.clientY || 0,
    visibility: 'hidden',
  });
  const getAnchorDimensions = () => {
    if (!blockRef?.current) { return { width: 0, height: 0 }; }
    return blockRef.current.getBoundingClientRect();
  };
  const getWindowDimensions = () => ({ width: window.innerWidth, height: window.innerHeight });
  const calculate = () => {
    let x = event?.clientX;
    let y = event?.clientY;
    const viewportSize = getWindowDimensions();
    const anchorRect = getAnchorDimensions();
    if (blockRef?.current && anchorRect && viewportSize) {
      if (x + anchorRect.width > window.innerWidth) {
        x -= anchorRect.width;
      }
      if (y + anchorRect.height > window.innerHeight) {
        y -= anchorRect.height;
      }
    }
    setStyle({
      left: x,
      top: y,
      visibility: 'visible',
    });
  };

  useLayoutEffect(() => {
    calculate();
  }, blockRef.current);
  useEffect(() => {
    window.addEventListener('contextmenu', onClose, { capture: true, once: true });
    window.addEventListener('click', onClose, { once: true, passive: true });
  }, []);
  if (!item || !event || typeof renderContextMenu !== 'function') {
    return null;
  }

  return ReactDOM.createPortal(
    <div className="context-menu" style={style} ref={blockRef}>
      {renderContextMenu(item)}
    </div>,
    document.body,
  );
}
